/**
 * Dictionary Utilities
 * 
 * This module contains utilities for working with dictionary-encoded values from Apache Arrow.
 */

/**
 * Check if a value is a Dictionary object from Apache Arrow
 */
export function isDictionaryObject(value: unknown): boolean {
  // Early return for null, undefined, or primitive values
  if (value === null || value === undefined) {
    return false;
  }
  
  if (typeof value !== 'object') {
    return false;
  }
  
  try {
    const anyValue = value as any;
    
    // First check if it's a string value from a dictionary that's already been decoded
    // Apache Arrow sometimes automatically decodes dictionary values to strings
    if (typeof anyValue === 'string') {
      return false;
    }
    
    // Check for common dictionary properties
    return Boolean(
      // Check for dictionary type property
      (anyValue.type && anyValue.type.dictionary === true) ||
      // Check for dictionary type name
      (anyValue.type && typeof anyValue.type.toString === 'function' && 
        anyValue.type.toString().includes('Dictionary')) ||
      // Check for dictionary methods with type property
      (typeof anyValue.get === 'function' && anyValue.type) ||
      // Check for dictionary constructor name
      (anyValue.constructor && 
       (anyValue.constructor.name === 'Dictionary' || 
        anyValue.constructor.name.includes('Dictionary'))) ||
      // Check for Apache Arrow specific dictionary properties
      (anyValue.dictionary && anyValue.indices) ||
      // Check for dictionary-encoded column type
      (anyValue.type && typeof anyValue.type === 'string' && 
       anyValue.type.toLowerCase().includes('dictionary'))
    );
  } catch (err) {
    console.warn('Error checking if value is dictionary:', err);
    return false;
  }
} 